import "./App.scss"
import React from 'react';
import {HashRouter as Router, Routes, Route, Navigate} from "react-router-dom";

import NavMenu from "./NavMenu";
import Footer from "./components/Footer";
import ConsignmentsPage from "./components/ConsignmentsPage";
import LoginPage from "./components/LoginPage";
import LogoutPage from "./components/LogoutPage";
import Auth from "./components/Auth";
import ForgotPasswordPage from "./components/ForgotPasswordPage";
import VehicleHiresPage from "./components/VehicleHiresPage";

const App = () => {

    return (
        <Router>
            <NavMenu />

            <main role="main" className="flex-grow-1">

                <div id="app-route-view">

                    <Routes>
                        <Route path="/logout" element={
                            <Auth redirectPath="/deliveries" allowAuthenticated>
                                <LogoutPage />
                            </Auth>
                        }/>

                        <Route path="/login" element={
                            <Auth redirectPath="/deliveries" allowUnauthenticated>
                                <LoginPage />
                            </Auth>
                        }/>

                        <Route path="/forgot-password" element={
                            <Auth redirectPath="/deliveries" allowUnauthenticated>
                                <ForgotPasswordPage />
                            </Auth>
                        }/>

                        <Route path="/deliveries" element={
                            <Auth allowAuthenticated>
                                <ConsignmentsPage />
                            </Auth>
                        }/>

                        <Route path="/hires" element={
                            <Auth allowAuthenticated>
                                <VehicleHiresPage />
                            </Auth>
                        }/>

                        <Route path="/" element={
                            <Navigate to="/login" />
                        }/>

                    </Routes>

                </div>

            </main>

            <Footer />

        </Router>
    );
}

export default App;
